import { FilterItem } from 'components/multi-filter/multi-filter';

export const IdentitiesFilters = (connections: string[]): FilterItem[] => {
  return [
    {
      title: 'Account status',
      filterId: 'account_status',
      filterColumns: ['display_name', 'login'],
      props: [
        {
          label: 'Active',
          value: 'true',
        },
        {
          label: 'Inactive',
          value: 'false',
        },
      ],
    },
    {
      title: 'Risk Rating',
      filterId: 'highest_severity',
      filterColumns: ['highest_severity'],
      props: [
        {
          label: 'Critical',
          value: '5',
        },
        {
          label: 'High',
          value: '4',
        },
        {
          label: 'Medium',
          value: '3',
        },
        {
          label: 'Low',
          value: '2',
        },
        {
          label: 'None',
          value: '0',
        },
      ],
    },
    {
      title: 'Identity Status',
      filterId: 'identity_status',
      filterColumns: ['identity_status'],
      props: [
        {
          label: 'External',
          value: 'true',
        },
        {
          label: 'Internal',
          value: 'false',
        },
      ],
    },
    {
      title: 'Team member',
      filterId: 'team_member',
      props: [
        {
          label: 'Member',
          value: true,
        },
        {
          label: 'Not a member',
          value: false,
        },
      ],
    },
    {
      title: 'Account type',
      filterId: 'account_type',
      filterColumns: ['display_name', 'login'],
      props: [
        {
          label: 'User',
          value: 'user',
        },
        {
          label: 'App',
          value: 'app',
        },
        {
          label: 'Service',
          value: 'service',
        },
      ],
    },
    {
      title: 'Has Admin Permissions',
      filterId: 'is_admin',
      filterColumns: ['count_admin_permissions'],
      props: [
        {
          label: 'true',
          value: true,
        },
        {
          label: 'false',
          value: false,
        },
      ],
    },
    {
      title: 'Watched',
      filterId: 'only_watched',
      props: [
        {
          label: 'Watched',
          value: true,
        },
        {
          label: 'Not Watched',
          value: false,
        },
      ],
    },
    {
      title: 'Hidden',
      filterId: 'only_hidden',
      props: [
        {
          label: 'Hidden',
          value: true,
        },
        {
          label: 'Not Hidden',
          value: false,
        },
      ],
    },

    {
      title: 'Source',
      filterId: 'source',
      filterColumns: ['scm_source'],
      props: [
        {
          label: 'GitHub',
          value: 'GitHub',
        },
        {
          label: 'GitLab',
          value: 'GitLab',
        },
        {
          label: 'BitBucket',
          value: 'BitBucket',
        },
        {
          label: 'AzureDevOps',
          value: 'AzureDevOps',
        },
        {
          label: 'JFrog',
          value: 'JFrog',
        },
      ].filter(
        (connector) =>
          connections.findIndex((item) => item === connector?.label) !== -1,
      ),
    },
  ];
};

export const IdentitiesFilterList: FilterItem[] = [
  {
    title: 'Account status',
    filterId: 'account_status',
    filterColumns: ['display_name', 'login'],
    props: [
      {
        label: 'Active',
        value: 'true',
      },
      {
        label: 'Inactive',
        value: 'false',
      },
    ],
  },
  {
    title: 'Has Admin Permissions',
    filterId: 'count_admin_permissions',
    filterColumns: ['count_admin_permissions'],
    props: [
      {
        label: 'true',
        value: true,
      },
      {
        label: 'false',
        value: false,
      },
    ],
  },
  {
    title: 'Identity Status',
    filterId: 'identity_status',
    filterColumns: ['identity_status'],
    props: [
      {
        label: 'External',
        value: 'true',
      },
      {
        label: 'Internal',
        value: 'false',
      },
      {
        label: 'Unknown',
        value: 'unknown',
      },
    ],
  },
  {
    title: 'Team member',
    filterId: 'team_member',
    props: [
      {
        label: 'Member',
        value: true,
      },
      {
        label: 'Not a member',
        value: false,
      },
    ],
  },
  {
    title: 'Account type',
    filterId: 'account_type',
    filterColumns: ['display_name', 'login'],
    props: [
      {
        label: 'User',
        value: 'user',
      },
      {
        label: 'App',
        value: 'app',
      },
      {
        label: 'Service',
        value: 'service',
      },
    ],
  },
  {
    title: 'Watched',
    filterId: 'only_watched',
    filterColumns: ['display_name', 'login'],
    props: [
      {
        label: 'Watched',
        value: true,
      },
      {
        label: 'Not Watched',
        value: false,
      },
    ],
  },
  {
    title: 'Hidden',
    filterId: 'only_hidden',
    filterColumns: ['display_name', 'login'],
    props: [
      {
        label: 'Hidden',
        value: true,
      },
      {
        label: 'Not Hidden',
        value: false,
      },
    ],
  },
  {
    title: 'Risk Rating',
    filterId: 'highest_severity',
    filterColumns: ['highest_severity'],
    props: [
      {
        label: 'Critical',
        value: '5',
      },
      {
        label: 'High',
        value: '4',
      },
      {
        label: 'Medium',
        value: '3',
      },
      {
        label: 'Low',
        value: '2',
      },
      {
        label: 'None',
        value: '0',
      },
    ],
  },
];
